<div fxLayout="column" fxLayoutAlign="center center" matTooltip="hoverText">
<img src="{{image}}" class="logo" matTooltip="hoverText"/><div class="description" matTooltip="OK!">{{description}}</div>
</div>